const actions = {
  SET_STATE: 'userProfileField/SET_STATE',
  GET: 'userProfileField/GET',
}

export default actions
